/** Maximum number of JavaScript characters accepted for create/refine prompts. */
export const PROMPT_MAX_LENGTH = 2_000;

/**
 * Maximum successful user prompts retained per preset. During refinement, the
 * current instruction plus prior history is also capped at this many messages.
 */
export const PRESET_PROMPT_HISTORY_LIMIT = 10;

export type PresetPromptKind = "create" | "refine";

export interface PresetPromptMessage {
  kind: PresetPromptKind;
  content: string;
}
